import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import enTranslation from './locales/en/translation.json'
import enPhase1Translation from './locales/en/phase1.json'
import esTranslation from './locales/es/translation.json'
import esPhase1Translation from './locales/es/phase1.json'
import deTranslation from './locales/de/translation.json'
import dePhase1Translation from './locales/de/phase1.json'
import ptTranslation from './locales/pt/translation.json'
import ptPhase1Translation from './locales/pt/phase1.json'
import ptOracleTranslation from './locales/pt/oracles.json'
import enOracleTranslation from './locales/en/oracles.json'
import esOracleTranslation from './locales/es/oracles.json'

const isPlainObject = (value) => Object.prototype.toString.call(value) === '[object Object]'

const mergeTranslations = (base, override) => {
  const result = { ...base }

  Object.entries(override || {}).forEach(([key, value]) => {
    if (isPlainObject(value) && isPlainObject(result[key])) {
      result[key] = mergeTranslations(result[key], value)
      return
    }

    result[key] = value
  })

  return result
}

const resources = {
  en: {
    translation: mergeTranslations(mergeTranslations(enTranslation, enPhase1Translation), enOracleTranslation),
  },
  es: {
    translation: mergeTranslations(mergeTranslations(esTranslation, esPhase1Translation), esOracleTranslation),
  },
  de: {
    translation: mergeTranslations(deTranslation, dePhase1Translation),
  },
  pt: {
    translation: mergeTranslations(mergeTranslations(ptTranslation, ptPhase1Translation), ptOracleTranslation),
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt',

    interpolation: {
      escapeValue: false,
    },
  })

export default i18n

const syncDocumentLanguage = (language) => {
  if (typeof document !== 'undefined') document.documentElement.lang = language || 'pt'
  if (typeof window !== 'undefined') window.dispatchEvent(new Event('languageChanged'))
}
i18n.on('languageChanged', syncDocumentLanguage)
syncDocumentLanguage(i18n.resolvedLanguage || i18n.language)
